/**
 * Created by lu on 2018/5/3.
 */
var nb = require('../../nb');
var getNoticeInfo = require('../../io/' + process.env.APP_ENV + '/getNoticeInfo'); //消息信息
var webSocket, userId, key;

var _env = process.env.APP_CONFIG;


module.exports = nb.define({
    parent: nb.Model,
    mapping: {
        noticeList: nb.model.List,
        msgWrap: require('./MsgWrap')
    },
    method: {
        init: function () {
            var self = this;
            self.set('noticeList', {
                itemType: require('../../view/notice/NoticeItem')
            });

            //ascb2b.asc-wines.com/webSocket  webSocketListen b2b正式环境
            //uat.b2b.humming-tech.com/webSocket webSocketListen  b2b测试环境
            //172.30.17.59:8082/webSocket   本地

            nb.model.onChange(nb.model.user, function (inEvent, inUser) {
                userId = parseInt(inUser.get('userId'));
                this._companyId = parseInt(inUser.get('companyId'));

                var postUrl = '';
                if (_env == 'uat')
                    postUrl = 'ascb2b.asc-wines.com/';
                else if (_env == 'product')
                    postUrl = 'ascb2b.asc-wines.com/';


                if ('WebSocket' in window) {   //websocket
                    webSocket = new WebSocket("wss://" + postUrl + "webSocket?userId=" + userId);
                }

                // else if ('MozWebSocket' in window) {
                //     webSocket = new MozWebSocket("wss://ascb2b.asc-wines.com/webSocketListen?userId="+userId);
                // } else {
                //     webSocket = new SockJS("wss://ascb2b.asc-wines.com/webSocketListen?userId="+userId);
                // }

                webSocket.onopen = function (evnt) {
                    //向后台发送消息时调用
                    webSocket.send("test");
                };

                //发送消息
                webSocket.onmessage = function (evnt) {
                    // 监听到后台发送消息
                    // this.setOpts({
                    //     msgWrap:{
                    //         count:evnt.data
                    //     }
                    // });
                    console.log(evnt.data);
                    self.getNoticeInfo();
                    self._showInfoState();
                };

                webSocket.onerror = function (evnt) {
                    console.log(evnt);
                };

                webSocket.onclose = function (evnt) {
                };

                this.getNoticeInfo();
            }, this);

            nb.model.onChange('changeLanguageReady', function (inEvent, inData) {
                key = inData;
                if (key == 'cn') {
                    self.set('noticeText', '公告：');
                } else if (key == 'en') {
                    self.set('noticeText', 'Notice：');
                }
            })


            //模拟消息传递
            // this.onChange('messageInfo',function () {
            //     this._showInfoState();
            // },this);

        },
        getNoticeInfo: function () {
            getNoticeInfo({
                data: {
                    userId: userId,
                    companyId: this._companyId
                },
                scope: this,
                success: function (inResp) {
                    var itemsRow = inResp.rows;
                    // var infoList = inResp.infoList || [];
                    this.setOpts({
                        // noticeList: {
                        //     items: inResp.noticeList || []
                        // },
                        msgWrap: {
                            count: inResp.num,
                            msgList: {
                                items: itemsRow.slice(0, 4) //截取4  //infoList.slice(0, 4)
                            }
                        }
                    })
                }
            });
        },

        //显示消息列表
        _showInfoState: function () {
            var self = this;
            $('.dropdown-wrap').addClass('uk-open');
            setTimeout(function () {
                self._hiddenInfoState();
            }, 6000);

        },

        //隐藏消息列表
        _hiddenInfoState: function () {
            $('.dropdown-wrap').removeClass('uk-open');
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/notice/Notice.js
// module id = 24
// module chunks = 0 1 2 3 4 7 8 9 10 12 13 14 15 16 18 19 20 21 22 23 25 26 27 28 29 30 34